import { render, staticRenderFns } from "./Identity.vue?vue&type=template&id=01bf4a6b"
import script from "./Identity.vue?vue&type=script&lang=js"
export * from "./Identity.vue?vue&type=script&lang=js"
import style0 from "./Identity.vue?vue&type=style&index=0&id=01bf4a6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports